import { SET_SATSER, SetSatserAction } from './Types';
import { Satser } from '../../Utilities/SatserApi';

export function setSatser(satser: Satser): SetSatserAction {
    return {
        type: SET_SATSER,
        payload: satser,
    };
}
